module.exports = __webpack_public_path__ + "static/img/header_logo.3601172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/header_logo.png
// module id = rclW
// module chunks = 11